module.exports = __webpack_public_path__ + "static/img/service_capability.89e0697.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/service_capability.png
// module id = YBeE
// module chunks = 0